import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {OnMounted} from "@Common/react/on-mounted";
import {Static2}   from "@Common/react/static-2";

export const VideoAutoplay = ({next}) => cs(
    ["ref", (_, next) => Static2({next})],
    ({ref}, next) => fragments(
        next(),
        OnMounted({
            action: async () => {
                try {
                    await ref.get().play();
                } catch (e) {
                    const events = [
                        "mousedown",
                        "keydown",
                    ];
                    const listener = () => {
                        ref.get().play();

                        for (const e1 of events) {
                            window.removeEventListener(e1, listener);
                        }
                    };

                    for (const e1 of events) {
                        window.addEventListener(e1, listener);
                    }
                }
            },
        }),
    ),
    ({ref}) => next({
        ref: (dom) => dom && ref.set(dom),
    })
);
